/* tslint:disable */
/* eslint-disable */
export enum RatingType {
  NotEnoughData = 'NotEnoughData',
  BelowAverage = 'BelowAverage',
  Average = 'Average',
  AboveAverage = 'AboveAverage'
}
